import { render, staticRenderFns } from "./Dementia.vue?vue&type=template&id=29bb8354&scoped=true"
import script from "./Dementia.vue?vue&type=script&lang=js"
export * from "./Dementia.vue?vue&type=script&lang=js"
import style0 from "./Dementia.vue?vue&type=style&index=0&id=29bb8354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bb8354",
  null
  
)

export default component.exports